// API Configuration utility
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://quality.silulumanzi.com';

// For legacy compatibility with window.base_url
if (typeof window !== 'undefined') {
  window.base_url = API_BASE_URL + '/';
}

export default {
  API_BASE_URL
};
